(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/expandable-article/assets/javascripts/expandable-article.js') >= 0) return;  svs.modules.push('/widgets/expandable-article/assets/javascripts/expandable-article.js');

'use strict';

class ExpandableArticle {
  constructor(options) {
    var _this$container, _this$container2, _this$container3;
    this.log = new svs.core.log.Logger('widgets:expandable-article');
    this.el = options.$el;
    this.collapsed = true;
    this.container = this.el[0];
    this.collapsedHeight = 400; 
    this.contentToggle = (_this$container = this.container) === null || _this$container === void 0 ? void 0 : _this$container.querySelector('.js-expandable-article-content-toggle');
    this.wrapper = (_this$container2 = this.container) === null || _this$container2 === void 0 ? void 0 : _this$container2.querySelector('.js-expandable-article-content-wrapper');
    this.scrollToTopContainer = (_this$container3 = this.container) === null || _this$container3 === void 0 ? void 0 : _this$container3.querySelector('.js-expandable-article-scroll-to-top-container');
    if (!this.contentToggle) {
      this.log.warn('Expandable article wont load, js-expandable-article-content-toggle was not found');
      return;
    }
    this.wrapper.style.height = "".concat(this.collapsedHeight, "px");
    this.addEventListeners();
  }
  trackExpandClick() {
    const trackingName = this.container.dataset.track;
    if (trackingName) {
      svs.components.analytics.trackEvent({
        category: 'Articles',
        action: 'Read more',
        opt_label: trackingName
      });
    }
  }
  toggleHandler() {
    if (this.collapsed) {
      this.contentToggle.setAttribute('aria-expanded', 'true');
      this.wrapper.style.height = "".concat(this.wrapper.scrollHeight, "px");
      this.contentToggle.textContent = 'Läs mindre';
    } else {
      this.contentToggle.setAttribute('aria-expanded', 'false');
      this.wrapper.style.height = "".concat(this.collapsedHeight, "px");
      this.contentToggle.textContent = 'Läs mer';
      this.scrollToTopContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    this.container.classList.toggle('expandable-article-collapsed');
    this.collapsed = !this.collapsed;
  }
  addEventListeners() {
    this.contentToggle.addEventListener('click', () => this.toggleHandler());
    this.contentToggle.addEventListener('click', () => this.trackExpandClick(), {
      once: true
    });
  }
  removeListeners() {
    this.contentToggle.removeListeners('click', () => this.toggleHandler(), this);
    this.contentToggle.removeEventListener('click', () => this.trackExpandClick(), {
      once: true
    });
  }
  destroy() {
    this.removeListeners();
  }
}
setGlobal('svs.widget.expandable_article.init', options => {
  if (options) {
    new ExpandableArticle(options);
  }
});

 })(window);